__turbopack_context__.v({
  "container": "styles-module__R0r4fW__container",
  "followCount": "styles-module__R0r4fW__followCount",
  "followCountOwnShop": "styles-module__R0r4fW__followCountOwnShop",
});
